import { render, staticRenderFns } from "./main-review-slide.vue?vue&type=template&id=ee5a838c&scoped=true"
import script from "./main-review-slide.vue?vue&type=script&lang=js"
export * from "./main-review-slide.vue?vue&type=script&lang=js"
import style0 from "./main-review-slide.vue?vue&type=style&index=0&id=ee5a838c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee5a838c",
  null
  
)

export default component.exports